import { render, staticRenderFns } from "./CardReporte.vue?vue&type=template&id=2fde9881&scoped=true&"
import script from "./CardReporte.vue?vue&type=script&lang=js&"
export * from "./CardReporte.vue?vue&type=script&lang=js&"
import style0 from "./CardReporte.vue?vue&type=style&index=0&id=2fde9881&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde9881",
  null
  
)

export default component.exports